import get from 'lodash/get'

/**
 * Check if we are on a given environment.
 *
 * @since  0.1.4
 *
 * @param  {string} compare The env to check.
 *
 * @return {bool}         Whether we are on the given environment.
 */
export const isEnv = compare => {
	switch (compare) {
	case 'dev':
	case 'development':
		return [ 'development', 'dev' ].includes(process.env.NODE_ENV)
	case 'prod':
	case 'production':
		return [ 'production', 'prod' ].includes(process.env.NODE_ENV)
	default:
		return false
	}
}

/**
 * Get an environment variable, with an optional fallback.
 *
 * @since  2.0.0
 *
 * @param  {string} key      The env variable to get.
 * @param  {mixed}  fallback The optional fallback value.
 *
 * @return {mixed}           The result.
 */
export const getVar = (key, fallback) => {
	return get(process.env, key, fallback)
}

export const currentEnv = process.env.NODE_ENV
